module.exports = __webpack_public_path__ + "static/foodstandslide-10-min-af37d0029003bf42c0e61e1961a0db21.jpg";